import React from 'react';
import { BsSearch } from 'react-icons/bs';
import './Navbar.css'

const Navbar = () => {
    return (
        <div className='navbar'>
            <h1>Find Your Watch 
                <p className='search-icon' ><BsSearch></BsSearch> </p>
            </h1>
            <h3>Choose Any 4 Watches</h3>
        </div>
    );
};

export default Navbar;